import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('admin@ndule.app');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (user) {
    nav('/');
    return null;
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await login(email, password);
      nav('/');
    } catch (e2: unknown) {
      setErr((e2 as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <form onSubmit={submit} className="bg-surface p-8 rounded-xl w-full max-w-md border border-border">
        <h1 className="text-accent text-3xl font-bold mb-2">Ndule Admin</h1>
        <p className="text-text2 text-sm mb-6">Sign in with an admin account</p>
        <label className="block text-text2 text-sm mb-1">Email</label>
        <input
          className="w-full mb-4 bg-bg border border-border rounded-md px-3 py-2 text-text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          autoComplete="email"
        />
        <label className="block text-text2 text-sm mb-1">Password</label>
        <input
          className="w-full mb-6 bg-bg border border-border rounded-md px-3 py-2 text-text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          autoComplete="current-password"
        />
        {err ? <div className="text-danger text-sm mb-4">{err}</div> : null}
        <button
          disabled={loading}
          className="w-full bg-accent text-bg font-semibold py-2 rounded-md hover:opacity-90 disabled:opacity-50"
          type="submit"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
